// import SHOP_DATA from '../../shop-data.json';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
// import { CategoriesContext } from '../../context/categories.context';
// import ProductCard from '../../components/product-card/product-card.component';
import {
  selectCategoriesMap,
  selecCategoriesIsLoading,
} from '../../store/categories/category.selector';
import CategoryPreview from '../../components/category-preview/category-preview.component';
import Spinner from '../../components/spinner/spinner.component';

const CategoriesPreview = () => {
  // const { categoriesMap } = useContext(CategoriesContext);
  const categoriesMap = useSelector(selectCategoriesMap);
  const isLoading = useSelector(selecCategoriesIsLoading);

  return (
    <Fragment>
      {isLoading ? (
        <Spinner />
      ) : (
        Object.keys(categoriesMap).map((title) => {
          const products = categoriesMap[title];
          return (
            <CategoryPreview key={title} title={title} products={products} />
          );
        })
      )}
    </Fragment>
  );
};

export default CategoriesPreview;
